import { motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import Loader from "../../../../components/Loader/Loader";
import "./micrositeDetailsMedia.scss";

const MicrositeDetailsMedia = ({ data, onLoadComplete }) => {
  const [isLoading, setIsLoading] = useState(true);
  const loadCalledRef = useRef(false); // ensure onLoadComplete called once per media
  const url = data?.mediaLink?.url;
  const mediaType = data?.mediaLink?.mediaType;


  // Reset loading state and call-tracker when URL changes
  useEffect(() => {
    setIsLoading(true);
    loadCalledRef.current = false;
  }, [url]);

  // helper to mark loaded (ensures onLoadComplete called once)
  const markLoaded = () => {
    if (!loadCalledRef.current) {
      loadCalledRef.current = true;
      setIsLoading(false);
      if (typeof onLoadComplete === "function") onLoadComplete();
    }
  };

  // helper to mark error (stop loader and call onLoadComplete to continue flow)
  const markError = () => {
    if (!loadCalledRef.current) {
      loadCalledRef.current = true;
      setIsLoading(false);
      if (typeof onLoadComplete === "function") onLoadComplete();
    }
  };

  const Wrapper = ({ children }) => (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.8,
        delay: 0.5,
        ease: [0, 0.71, 0.2, 1.01],
      }}
      className="media-container"
      style={{ paddingBottom: "0px" }}
    >
      <div className="slide">
        {isLoading && <Loader />}
        {children}
      </div>
    </motion.div>
  );

  if (!mediaType || !url) return null;

  // VIDEO (YouTube / Vimeo / Social)
  if (mediaType === "SOCIAL_MEDIA" || mediaType === "VIMEO_MEDIA") {
    return (
      <Wrapper>
        <ReactPlayer
          className="video-player"
          url={url}
          controls={true}
          height="100%"
          width="100%"
          config={{
            youtube: {
              playerVars: {
                fs: 1,
                modestbranding: 0,
                showinfo: 1,
                allowfullscreen: true,
              },
            },
            vimeo: {
              playerOptions: {
                title: 1,
                byline: 1,
                portrait: 1,
                dnt: 1,
              },
            },
          }}
          onReady={() => {
            markLoaded();
          }}
          onError={() => {
            // ReactPlayer onError fires for load/playback errors
            markError();
          }}
          // keep hidden until ready
          style={{
            opacity: isLoading ? 0 : 1,
            transition: "opacity 0.3s ease",
          }}
        />
      </Wrapper>
    );
  }

  // IMAGE
  if (mediaType === "IMAGE" || mediaType === "DEFAULT") {
    const altText = mediaType === "DEFAULT" ? "Default Media" : "Media";
    const bgColor = mediaType === "DEFAULT" ? "lightgray" : "white";
    const border = mediaType === "DEFAULT" ? "1px solid #ccc" : "none";

    return (
      <Wrapper>
        <img
          src={url}
          alt={altText}
          className="carousel-image"
          onLoad={() => {
            markLoaded();
          }}
          onError={() => {
            // If image cannot load, mark as error (hide loader)
            markError();
          }}
          style={{
            // use opacity instead of visibility so browser still loads the image
            opacity: isLoading ? 0 : 1,
            transition: "opacity 0.3s ease",
            backgroundColor: bgColor,
            border: border,
            width: "100%",
            height: "auto",
            objectFit: "contain",
          }}
        />
      </Wrapper>
    );
  }

  return null;
};

export default MicrositeDetailsMedia;

